/* eslint-disable react/no-unknown-property */
import React from 'react';

import { Grid, GridItem } from 'react-scale/components/website/big/main/Grid';
import FeaturesList from 'react-scale/components/website/big/open-datasets/shared/FeaturesList';
import Sensors from 'react-scale/components/website/big/open-datasets/waterloo/Sensors';

import { mq } from 'react-scale/components/website/big/Themes';

class SensorCalibration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      highlight: ''
    };
  }

  updateHighlight = type => {
    this.setState({ highlight: type });
  };

  render() {
    const { highlight } = this.state;

    const { background, sensorDetailsList, dataset } = this.props;

    return (
      <section id="sensor-calibration">
        <div className="sensor-calibration-block">
          <div className="car-sensor-illustration">
            <Grid margin={{ xl: 0, lg: 0, md: 0, xs: 0 }} vAlign="center">
              <GridItem lg="1 / 5" xl="1 / 5" md="1 / 5">
                <FeaturesList
                  items={sensorDetailsList}
                  iconSrc={dataset}
                  onHover={this.updateHighlight}
                />
              </GridItem>
              <GridItem xl="5 / 13" lg="5 / 13" md="5 / 9">
                <div className="illustration-wrapper">
                  {dataset === 'waterloo' && (
                    <div className="car-sensors-graphic">
                      <Sensors className={highlight} />
                    </div>
                  )}
                  {dataset !== 'waterloo' && (
                    <img
                      className="car-sensors-graphic"
                      src={`/static/img/website/open-datasets/${dataset}/car-sensors.svg`}
                      alt="Car Sensors"
                    />
                  )}
                </div>
              </GridItem>
            </Grid>
          </div>
        </div>
        <style jsx>{`
          .sensor-calibration-block {
            overflow: hidden;
          }

          .car-sensor-illustration {
            position: relative;
          }
          .car-sensor-illustration:before {
            position: absolute;
            top: 0;
            left: 50%;
            right: 0;
            bottom: 0;
            background: ${background};
            z-index: 0;
          }
          @media (min-width: ${mq.lg}) {
            .car-sensor-illustration:before {
              content: '';
            }
          }
          .car-sensor-illustration .illustration-wrapper {
            background: ${background};
          }
          .car-sensor-illustration .car-sensors-graphic {
            max-width: 350px;
            margin: 0 auto;
            position: relative;
            z-index: 10;
          }
          @media (min-width: ${mq.xl}) {
            .car-sensor-illustration .car-sensors-graphic {
              max-width: 100%;
            }
          }
        `}</style>
      </section>
    );
  }
}

SensorCalibration.defaultProps = {
  sensorDetailsList: [
    {
      text: 'LiDAR extrinsics'
    },
    {
      text: 'Camera extrinsics'
    },
    {
      text: 'Camera intrinsic calibration'
    },
    {
      text: 'IMU extrinsics'
    }
  ]
};

export default SensorCalibration;
